import { render, staticRenderFns } from "./TypeBenefits.vue?vue&type=template&id=1459b14a&"
import script from "./TypeBenefits.vue?vue&type=script&lang=js&"
export * from "./TypeBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports